export default __webpack_public_path__ + "static/media/sun-light.ac36a5ec.svg";